import { Action } from '@ngrx/store';
import { ILegalEntity } from '@cemex-core/types-v2';

export enum ActionTypes {
    LOAD_LEGAL_ENTITY = '[Legal Entity] Load Legal Entity',
    LOAD_LEGAL_ENTITY_FAILURE = '[Legal Entity] Load Legal Entity Failure',
    SET_LEGAL_ENTITY = '[Legal Entity] Set Legal Entity',
}

export class LoadLegalEntity implements Action {
    readonly type: string  = ActionTypes.LOAD_LEGAL_ENTITY;

    constructor(public payload?: any) {}
}

export class LoadLegalEntityFailure implements Action {
    readonly type: string = ActionTypes.LOAD_LEGAL_ENTITY_FAILURE;

    constructor(public payload?: any) {}
}

export class SetLegalEntity implements Action {
    readonly type: string = ActionTypes.SET_LEGAL_ENTITY;

    constructor(public payload: ILegalEntity) {}
}

export type Actions =
    | LoadLegalEntity
    | LoadLegalEntityFailure
    | SetLegalEntity;
